import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PoAcknowledgmentService {
  constructor(private _http: HttpClient, private _cs: CommonService) { }


  sendPOAcknowledgment = (orderId: number) => {
    const payload = {
      order_id: orderId
    };

    return this._http.post<any>(environment.API_URL + 'po-acknowledgment/send', payload, this._cs.setHeader());
  }
}
